import axiosInstance from "../axiosInstance"
import type {
  MotoModelResponseDto,
  CreateMotoModelDto,
  UpdateMotoModelDto,
  MotoModelListParams,
  MotoModelListResponseDto,
  DeleteMotoModelResponseDto,
} from "../types/motoModel.types"

/**
 * Moto Model API Client
 * Direct API calls using axios instance
 */
export const motoModelClient = {
  // Get moto model by ID
  getMotoModelById: (id: string): Promise<MotoModelResponseDto> => {
    return axiosInstance.get(`/moto-models/${id}`)
  },

  // List moto models with filters
  getMotoModels: (params?: MotoModelListParams): Promise<MotoModelListResponseDto> => {
    return axiosInstance.get("/moto-models", { params })
  },

  // Create moto model (Admin only)
  createMotoModel: (data: CreateMotoModelDto): Promise<MotoModelResponseDto> => {
    return axiosInstance.post("/moto-models", data)
  },

  // Update moto model (Admin only)
  updateMotoModel: (id: string, data: UpdateMotoModelDto): Promise<MotoModelResponseDto> => {
    return axiosInstance.put(`/moto-models/${id}`, data)
  },

  // Delete moto model (Admin only)
  deleteMotoModel: (id: string): Promise<DeleteMotoModelResponseDto> => {
    return axiosInstance.delete(`/moto-models/${id}`)
  },
}

